var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code-container",style:(_vm.codeStyle)},[_c('div',{attrs:{"id":'qrcode' + Object.values(_vm.myid).join('')}})])}
var staticRenderFns = []

export { render, staticRenderFns }